var _style, _g, _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4FA06C;}\n\t.st1{fill:#63C187;}\n\t.st2{fill:#377745;}\n\t.st3{fill:#2C5939;}\n\t.st4{fill:#387A47;}\n\t.st5{clip-path:url(#SVGID_00000146475320216868062970000004085168617750172812_);fill:#3B804B;}\n\t.st6{fill:#3B804B;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#2D5A3A;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,1.8h8.1v5.1H6V2.5C6,2.1,6.3,1.8,6.7,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,1.8h-8.1v5.1h8.8V2.5C23.5,2.1,23.2,1.8,22.8,1.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.9,
    className: "st2",
    width: 8.8,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 6.9,
    className: "st0",
    width: 8.8,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    className: "st3",
    width: 8.8,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 12,
    className: "st4",
    width: 8.8,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6,17.1h8.8v5.1H6.7c-0.4,0-0.7-0.3-0.7-0.7V17.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M22.8,1.8h-8.1H6.7C6.3,1.8,6,2.1,6,2.5v4.4V12v5.1v4.4c0,0.4,0.3,0.7,0.7,0.7h8.1h8.1 c0.4,0,0.7-0.3,0.7-0.7v-4.4V12V6.9V2.5C23.5,2.1,23.2,1.8,22.8,1.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091713531231448764310000015749347578785377672_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000091713531231448764310000015749347578785377672_)",
      fill: "#3B804B"
    },
    d: "M6.3,17.8L6.3,17.8 c-3.2,0-5.8-2.6-5.8-5.8v0c0-3.2,2.6-5.8,5.8-5.8h0c3.2,0,5.8,2.6,5.8,5.8v0C12.1,15.2,9.5,17.8,6.3,17.8z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M11.1,6.2H1.5c-0.5,0-1,0.4-1,1v9.7c0,0.5,0.4,1,1,1h9.7c0.5,0,1-0.4,1-1V7.2C12.1,6.6,11.7,6.2,11.1,6.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M7.1,12L9,8.9H7.6l-0.8,1.5c-0.2,0.3-0.3,0.5-0.4,0.8c-0.1-0.2-0.3-0.5-0.4-0.8L5,8.9H3.6L5.5,12l-2.1,3.2h1.6 l0.8-1.4C6,13.3,6.1,13,6.3,12.7c0.2,0.3,0.3,0.6,0.6,1.1l0.8,1.4h1.6L7.1,12z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M14.7,17.1h8.8v4.4c0,0.4-0.3,0.7-0.7,0.7h-8V17.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.4d55123111542aa9167214aae8ff2434.svg";
export { ForwardRef as ReactComponent };